import React from 'react'

export const LoanDisclosure = ({ isResidential }: { isResidential: boolean }) => {
  return (
    <div>
      <h4 className="mb-3"><b>Important Reminders</b></h4>
      <ul className="list text d-flex flex-column gap-3">
        <li>
          Installers, contractors, sales representatives, and other third parties are not authorized to explain,
          negotiate, or make representations regarding Climate First Bank's loan products, credit policies, or approval
          criteria beyond the information outlined.
        </li>
        {isResidential && <>
          <li>
            Always direct customers to Climate First Bank for any loan-specific questions.
          </li>
          <li>
            A Climate First Bank banker will contact the customer directly to conduct a
            <b> Welcome Call</b>, during which all loan details, terms, and conditions will be thoroughly reviewed.
          </li>
        </>}
        <li>
          Providing inaccurate or unauthorized representations about Climate First Bank's loan products is a violation
          of your Installer Agreement and may result in removal from the program.
        </li>
      </ul>
      <h4 className="mt-3 mb-3"><b>Separation of Installer Contract and Loan Application</b></h4>
      <p className="text-dark">
        <b>Climate First Bank does not operate under a dealer model.</b> Unlike the dealer model — where the installer
        or dealer acts as an intermediary in the financing process, originates loan applications, presents loan offers,
        and may influence lending terms on behalf of the lender — Climate First Bank maintains a direct lending
        relationship with the customer. This means:
      </p>
      <ul className="list text d-flex flex-column gap-3">
        <li>
          <b>The bank works directly with the borrower.</b> All loan communication, application processing, credit
          decisions, disclosures, and closing are conducted by Climate First Bank personnel — not through the
          installer or any third party.
        </li>
        <li>
          <b>There are no dealer fees, rate markups, or installer-influenced pricing.</b> Because Climate First Bank
          does not use the dealer model, the customer's loan terms are determined solely by the bank based on
          creditworthiness, loan amount, and selected term — free from installer or dealer influence.
        </li>
        <li>
          <b>The contract between the installer and the customer is completely separate from the loan application </b>
          with Climate First Bank. These are two independent agreements, and customers should understand this
          distinction clearly.
        </li>
        <li>
          <b>Climate First Bank is not a party to, and has no involvement in, the contract between the customer and
            the installer.</b> The bank does not negotiate, review, approve, or guarantee any terms, pricing, scope of
          work, warranties, or obligations contained in the installer-customer contract.
        </li>
        <li>
          <b>The installer is not involved at any stage of the loan application process.</b> The loan application,
          credit review, underwriting, approval, and closing are handled exclusively by Climate First Bank. Installers
          shall not collect loan application information, represent loan approval status, or participate in any lending
          decisions on behalf of Climate First Bank.
        </li>
        <li>
          Any disputes, claims, or issues arising from the installer-customer contract — including but not limited to
          project scope, installation quality, timelines, or warranties — are solely between the installer and the
          customer and do not affect the customer's obligations under their loan agreement with Climate First Bank.
        </li>
      </ul>
    </div>
  )
}
